import { render, staticRenderFns } from "./forgottenPassword.vue?vue&type=template&id=3ccf16b4&scoped=true&lang=pug&"
import script from "./forgottenPassword.vue?vue&type=script&lang=js&"
export * from "./forgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccf16b4",
  null
  
)

export default component.exports